var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M30.892 1.548C30.722 1.212 30.377 1 30 1H2.00001C1.62301 1 1.27801 1.212 1.10801 1.548C0.938007 1.884 0.971007 2.287 1.19301 2.592L12 17.327V30C12 30.553 12.447 31 13 31H19C19.553 31 20 30.553 20 30V17.327L30.807 2.592C31.029 2.287 31.062 1.884 30.892 1.548Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterTool);
export default __webpack_public_path__ + "static/media/filter-tool.7aeaa447741c3ac6f0529763e3c99172.svg";
export { ForwardRef as ReactComponent };